import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=8e582d0c&scoped=true&"
import script from "./InformationList.vue?vue&type=script&lang=js&"
export * from "./InformationList.vue?vue&type=script&lang=js&"
import style0 from "./InformationList.vue?vue&type=style&index=0&id=8e582d0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e582d0c",
  null
  
)

export default component.exports